<template>
    <div class="chip chip-container">
        <div class="chip-thumbnail" v-if="thumbnailed">
            <slot name="thumbnail"></slot>
        </div>

        <div class="chip-text">
            <slot name="text"></slot>
        </div>

        <div
            class="chip-remove"
            v-if="type=='active'"
            @click="close"
        >
            <span class="icon-ic-dismiss"></span>
        </div>

        <transition name="bubble-up">
            <div class="chip-bage" v-if="bage">
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: ['type', 'thumbnailed', 'bage'],

    methods: {
        close (e) {
            this.$emit('close', e);
        }
    }
}
</script>

<style>
/*
    Style Types:
    1 outlined
    2 colored
    3 elevated
*/
</style>
